export class TmModalData {
  /** 彈窗表頭標題 */
  title ? = '';
  /** 彈窗內文 */
  content ? = '';
  /** 彈窗關閉按鈕標籤 */
  cancelBtnLabel ? = 'CANCEL';
  /** 彈窗開啟按鈕標籤 */
  okBtnLabel ? = 'OK';
  /** 是否顯示彈窗表頭上的關閉叉叉按鈕 */
  showClose ? = true;

  constructor(param?: { title?: string, content?: string, okBtnLabel?: string, cancelBtnLabel?: string, showClose?: boolean }) {
    if (!param) { return this; }
    if (typeof param.showClose === 'boolean') { this.showClose = param.showClose; }
    if (param.okBtnLabel) { this.okBtnLabel = param.okBtnLabel; }
    if (param.cancelBtnLabel) { this.cancelBtnLabel = param.cancelBtnLabel; }
    if (param.content) { this.content = param.content; }
    if (param.title) { this.title = param.title; }
    return this;
  }
}
